import React, { Component } from "react";
import { toast } from "react-toastify";
import simulationattack from "../../../assets/create_campaign/simulationattack.png";
import simulationandtraining from "../../../assets/create_campaign/simulationandtrain.png";
import { isSimulationTypeAllowed } from "../simulation-compatibility";
import "./steps.css";

export default class SimulationTypeStep extends Component {
	handleSelect = (type) => {
		if (!isSimulationTypeAllowed(this.props.attackType, type)) {
			toast.error(`${type} is not available for ${this.props.attackType} campaigns`);
			return;
		}
		if (this.props.onUpdate) {
			this.props.onUpdate(type);
		}
	}

	validate = () => {
		if (!this.props.simulationType) {
			toast.error("Please select a simulation type");
			return false;
		}
		return true;
	}

	render() {
		const { simulationType, attackType, readOnly } = this.props;
		const trainingAllowed = isSimulationTypeAllowed(attackType, "Simulation Attack + Training");
		
		return (
			<div className="step-content-wrapper">
				<div className="step-header">
					<h4>Choose Simulation Type</h4>
					<p>Select whether you want to simulate an attack alone or combine it with training for better learning outcomes.</p>
				</div>
				<div className={`simulation-type-cards ${readOnly ? "read-only" : ""}`}>
					<div
						className={`simulation-card ${simulationType === "Simulation Attack" ? "selected" : ""}`}
						onClick={() => !readOnly && this.handleSelect("Simulation Attack")}
						style={
							readOnly
								? simulationType === "Simulation Attack"
									? { pointerEvents: "none" }
									: { pointerEvents: "none", opacity: 0.9, filter: "grayscale(100%)" }
								: {}
						}
					>
						<div className="simulation-card-image">
							<img src={simulationattack} alt="Simulation Attack" loading="eager" />
						</div>
						<div className="simulation-card-content">
							<h5>Simulation Attack</h5>
							<p>Only assess employee response through a simulated attack to understand awareness levels.</p>
						</div>
					</div>
					<div
						className={`simulation-card ${simulationType === "Simulation Attack + Training" ? "selected" : ""} ${!trainingAllowed ? "disabled" : ""}`}
						onClick={() => !readOnly && trainingAllowed && this.handleSelect("Simulation Attack + Training")}
						aria-disabled={readOnly || !trainingAllowed}
						title={!trainingAllowed ? `Simulation Attack + Training is not available for ${attackType} campaigns` : undefined}
						style={
							readOnly || !trainingAllowed
								? simulationType === "Simulation Attack + Training"
									? { pointerEvents: "none" }
									: { pointerEvents: "none", opacity: 0.55, filter: "grayscale(100%)" }
								: {}
						}
					>
						<div className="simulation-card-image">
							<img src={simulationandtraining} alt="Simulation Attack + Training" loading="eager" />
						</div>
						<div className="simulation-card-content">
							<h5>Simulation Attack + Training</h5>
							<p>
								{trainingAllowed
									? "Assess employee response through a simulated attack and automatically assign relevant training."
									: `Not available for ${attackType} campaigns.`}
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
